import { JsonSchemaProperty, RecordPageRenderContext } from "../../../../types";
import { RecordPageFormLayout } from "../../../../utils/styled";
import { resolveCustomStyle } from "../../style-config";
import { renderField } from "./recordPage.field";
import { renderAdditionalFields } from "./recordPage.renderers";
import SetupTable from "../setup/SetupTable";
import { SCHEMA_TITLES } from "../../constants";

function filterInventoryBuildingsFields(
  sectionKey: string,
  sectionValue: string[],
): string[] {
  switch (sectionKey) {
    case "building_details":
      // "is_enabled" is rendered inside the section header, not the form
      return sectionValue.filter((key) => key !== "is_enabled");

    // case "another_section":
    //   return sectionValue.filter(...);

    default:
      return sectionValue;
  }
}

function resolveRenderedFields(
  sectionKey: string,
  sectionValue: string[],
  ctx: RecordPageRenderContext,
): string[] {
  switch (ctx.schema.title) {
    case SCHEMA_TITLES.INVENTORY_BUILDINGS:
      return filterInventoryBuildingsFields(sectionKey, sectionValue);

    // Future setups go here:
    // case SCHEMA_TITLES.SOME_OTHER_SETUP:
    //   return filterSomeOtherSetupFields(sectionKey, sectionValue);

    default:
      return sectionValue;
  }
}

export function renderSectionForm({
  sectionKey,
  sectionValue,
  ctx,
  explicitSectionValueWithProperty,
}: {
  sectionKey: string;
  sectionValue: string[];
  ctx: RecordPageRenderContext;
  explicitSectionValueWithProperty?: Record<string, JsonSchemaProperty>;
}): JSX.Element {
  const renderedSectionFields = resolveRenderedFields(
    sectionKey,
    sectionValue,
    ctx,
  );

  return (
    <>
      <RecordPageFormLayout
        $customStyle={resolveCustomStyle({
          applicability: "section-form",
          selectedSetup: ctx.selected.setup.value,
          sectionKey,
          isRecordOpen: ctx.isRecordOpen,
        })}
      >
        {renderedSectionFields.map((key) =>
          renderField(key, ctx, explicitSectionValueWithProperty?.[key]),
        )}

        {renderAdditionalFields(sectionKey, ctx)}
      </RecordPageFormLayout>

      {ctx.shouldRenderSetupTable && !explicitSectionValueWithProperty && (
        // to align with the setup table inside the form
        <div style={{ marginLeft: "-1rem", marginRight: "-1rem" }}>
          <SetupTable
            rowDataReducerState={ctx.rowDataReducerState}
            dispatch={ctx.dispatch}
            effectiveGridFields={ctx.effectiveGridFields}
          />
        </div>
      )}
    </>
  );
}
